import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

class Notification extends Component {
  render() {
    const { notification } = this.props;

    return (
      <Alert
        bsStyle={notification.status}
      >
        <p>
          {notification.title && notification.title + ' : '}
        </p>
        <h4>{notification.message}</h4>
      </Alert>
    );
  }
}

Notification.propTypes = {
  notification: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    status: PropTypes.string
  }).isRequired
};

export default Notification;